<template>
  <FormEmployee
    :jobTitle="jobTitle"
    :foots="foots"
    :divisions="divisions"
    :positions="positions"
    :jobLevel="jobLevel"
    :companies="companies"
    :gender="gender"
    :japaneseLevel="japaneseLevel"
    :workType="workType"
    :workShift="workShift"
    :informationEmployee="informationEmployee"
    :skillSheet="skillSheet"
    :skill="skill"
    :experience="experience"
    :menuStatus="menuStatus"
    :selectedSkill="selectedSkill"
    :selectedExperience="selectedExperience"
    v-on:submitUpdateEmployee="submitUpdateEmployee"
  />
</template>

<script>
import FormEmployee from "@/components/Employees/FormEmployee.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_employee_update"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    FormEmployee
  },

  data() {
    return {
      idEmployee: "",
      id: "",
      selectedSkill: [],
      selectedExperience: [],
      menuStatus: false
    };
  },

  computed: {
    ...mapGetters({
      informationEmployee: "employee/getEmployee",
      jobTitle: "commons/jobTitle",
      foots: "commons/foots",
      divisions: "commons/divisions",
      positions: "commons/positions",
      jobLevel: "commons/jobLevel",
      companies: "commons/companies",
      gender: "commons/gender",
      japaneseLevel: "commons/japaneseLevel",
      workType: "commons/workType",
      workShift: "commons/workShift",
      skillSheet: "skillsheet/skillSheet"
    })
  },

  async created() {
    this.idEmployee = this.$route.params.id;
    if (this.idEmployee) {
      await this.$store.dispatch("employee/getEmployee", this.idEmployee);
    }
    await this.$store.dispatch("commons/getJobLevel");
    this.showSkillSheet();
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    async submitUpdateEmployee(formData) {
      // add data to form data
      this.id = formData.getAll("id");

      this.setLoading(true);
      await this.$store
        .dispatch("employee/updateEmployee", {
          data: formData,
          id: this.idEmployee
        })
        .then(() => {
          let message = this.$t("employee.popup.update_employee_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: `/employees/detail/${this.id}` });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    async showSkillSheet() {
      let employeeId = await this.$route.params.id;
      if (employeeId) {
        await this.$store.dispatch("skillsheet/showSkillSheet", employeeId);
      }
      this.skill = this.skillSheet.skillCheckRank;
      this.experience = this.skillSheet.skillCheckExperience;
    //   this.selectedSkill = this.skillSheets.skillCheckRank;
    // this.selectedExperience = this.skillSheets.skillCheckExperience;
   },
    showMenuSkill() {
      this.menuStatus = !this.menuStatus;
    }
  }
};
</script>
